import HostConfig from '@/config/host-config'
export default {
  // 批量匹配老师模板路径
  matchTeachersPath: HostConfig.templatePath + '/批量匹配老师.xlsx',
  // 批量匹配老师模板路径
  subjectMatchTeachersPath: HostConfig.templatePath + '/评卷教师按题批量匹配.xlsx',
  // 批量匹配学校模板路径
  matchSchoolsPath: HostConfig.templatePath + '/批量匹配学校.xlsx',
  // 导入下属机构或学校模板路径
  importOrgsPath: HostConfig.templatePath + '/导入下属机构或学校模板.xlsx',
  // 导入考生模板路径
  importCandidatesPath: HostConfig.templatePath + '_bak/importStudent.xls',
  // 导入选考学生模板路径
  importElectiveStudensPath: HostConfig.templatePath + '/importStudent-新高考.xls',
  // 学校考试导入考生模板路径
  importCandidatesSchoolPath: HostConfig.templatePath + '/importStudent-school.xls',
  // 学校考试导入选考学生模板路径
  importElectiveStudensSchoolPath: HostConfig.templatePath + '/importStudent-school-新高考.xls',
  // 导入机构教师模板路径
  importTeachersFromOrgPath: HostConfig.templatePath + '/import-teachers-from-edu-20210407.xls',
  // 导入机构用户模板路径
  importUsersFromOrgPath: HostConfig.templatePath + '/importUser.xlsx',
  // 导入机构教研员模板路径
  importResearchUserFromOrgPath: HostConfig.templatePath + '/importResearchUser.xlsx',
  // 导入学校学生模板路径
  importStudentsFromSchoolPath: HostConfig.templatePath + '_bak/import-students.xls',
  // 导入学校学生模板路径,新高考版
  importStudentsFromSchoolPathNewGK: HostConfig.templatePath + '_bak/import-students-新高考.xls',
  // 导入学校教师模板路径
  importTeachersFromSchoolPath: HostConfig.templatePath + '/import-teachers-20210407.xls'
}



// WEBPACK FOOTER //
// ./src/util/template-dictionary.js